import classNames from 'classnames';
import React, { forwardRef, use } from 'react';

import { getNewButtonCss } from 'src/components/facilities/buttonCss';
import type { LinkButtonProps } from 'src/components/facilities/link-button';
import LinkButton from 'src/components/facilities/link-button';
import { createHeaderButtonBorderStyling } from 'src/components/layout/redesign/header-mobile/header-mobile-helper';
import { SiteContext } from 'src/context/site-context';
import type { ButtonStyle, RedesignButtonStyle } from 'src/enums/button-style';

import type { GeneralRedesignButtonStyle } from '../../../../../cms/common-widgets/button-widget';

export type HeaderButtonLinkProps = {
  type: 'link';
  buttonProps: Queries.RedesignButton;
  handleClick?: () => void;
  className?: string;
  contentClassName?: string;
};

type HeaderSimpleButtonProps = {
  type: 'button';
  text: string;
  handleClick: () => void;
  buttonStyle?: GeneralRedesignButtonStyle;
  className?: string;
  contentClassName?: string;
};

export type HeaderButtonProps = HeaderButtonLinkProps | HeaderSimpleButtonProps;

const HeaderButton = forwardRef<HTMLElement, HeaderButtonProps>((props, ref) => {
  const { styling } = use(SiteContext);

  if (props.type === 'link') {
    return (
      props.buttonProps.showButton && (
        <LinkButton
          {...(props.buttonProps as unknown as LinkButtonProps)}
          buttonStyle={props.buttonProps.buttonStyle as ButtonStyle}
          buttonType="grid-button"
          gtmTrackingId="header-button"
          customButtonStyle={[
            getNewButtonCss(props.buttonProps.buttonStyle as RedesignButtonStyle, styling),
            createHeaderButtonBorderStyling(styling, props.buttonProps.buttonStyle),
          ]}
          iconView={props.buttonProps.buttonIcon}
          handleClick={props.handleClick}
          goToGlobal={!!props.buttonProps.goToGlobal}
          className={props.className}
          contentClassName={props.contentClassName}
          isRedesignButton
          ref={ref}
        />
      )
    );
  } else {
    return (
      <button
        ref={ref as React.ForwardedRef<HTMLButtonElement>}
        type="button"
        className={classNames(props.className, props.contentClassName)}
        css={[
          getNewButtonCss(props.buttonStyle, styling),
          createHeaderButtonBorderStyling(styling, props.buttonStyle),
        ]}
        onClick={props.handleClick}
      >
        {props.text}
      </button>
    );
  }
});

HeaderButton.displayName = 'HeaderButton';

export default HeaderButton;
